module.exports = __webpack_public_path__ + "static/media/DSC_2321.df388d4a.jpg";